export enum ParticipantAwardSelectionOption {
    Accept = 1,
    Decline = 2,
}